import React from 'react';
import ReactDOM from 'react-dom';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  MODAL_STYLES: {
    backgroundColor: 'white',
    borderRadius: 5,
    width: 500,
    minHeight: 300,
    maxHeight: 500,
    padding: 20,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '20px',
    top: '50%',
    left: '50%'
  },
  OVERLAY_STYLES: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, .7)',
    zIndex: 1000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}));

export default function PortalModal({ open, children, onClose }) {
  const classes = useStyles();
  if (!open) return null;

  return ReactDOM.createPortal(
    <>
      <div dir="ltr" className={classes.OVERLAY_STYLES}>
        {children}
      </div>
    </>,
    document.getElementById('portal')
  );
}
